import React, { useLayoutEffect, useRef } from 'react';
import { useLocation, Location } from 'react-router-dom';

export const useHashLink = (
    hash: string,
    location: Location,
    ref: React.MutableRefObject<HTMLDivElement | null>,
    defer = false,
) => {
    useLayoutEffect(() => {
        if (location.hash === hash && !defer) {
            ref.current?.scrollIntoView({ block: 'center' });
        }
        // No need to update on ref change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.hash, hash, defer]);

    return;
};

/*
 * Add a link that that will be jumped to on the page if the "/#hash" part of the URL
 * matches. Importantly, the jump will happen both when the hash changes and when
 * the component is mounted, event if it is not there on initial page render.
 *
 * The `hash` prop should include the hash mark - `hash='#some-path`
 *
 */

export const JumpToHashLink: React.FC<{ hash: string; defer?: boolean }> = ({
    hash,
    defer = false,
    children,
}) => {
    const location = useLocation();
    const ref = useRef<HTMLDivElement | null>(null);

    useHashLink(hash, location, ref, defer);

    return (
        <>
            <div ref={ref} id={hash}>
                {children}
            </div>
        </>
    );
};
